import { useQuery } from '@tanstack/react-query';
import type { CompetitorRun } from '@seo/types';
import { apiGet } from '@/lib/api';
import { isTerminal } from '@/lib/queryClient';

export function useCompetitorRun(id: string | undefined) {
  return useQuery({
    queryKey: ['competitor-run', id],
    queryFn: () => apiGet<CompetitorRun>(`/v1/competitor-runs/${id}`),
    enabled: !!id,
    refetchInterval: (q) => (isTerminal(q.state.data?.status) ? false : 5_000),
  });
}
